module.exports = __webpack_public_path__ + "img/image_slide2_2.bdefd420.png";